import { StyleSheet } from 'aphrodite';
import { aceGray, background } from '../../../styles/colors';
import { THEME } from '../../Theme/theme';

const { colors } = THEME;

export const s = StyleSheet.create({
	popup: {
		maxWidth: 600,
		width: '90vw',
		maxHeight: '90vh',
		height: 700,
		display: 'flex',
		flexDirection: 'column',
		padding: 0,
		[THEME.queries.md]: {
			width: '95vw',
			height: '90vh',
		},
	},
	header: {
		borderBottom: `1px solid ${aceGray}`,
		padding: '16px 24px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: 8,
		flexShrink: 0,
	},
	headerStart: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	leoAvatar: {
		width: 40,
		height: 40,
	},
	headerTitle: {
		fontSize: '1rem',
		lineHeight: '1.5rem',
		fontWeight: 'bold',
		margin: 0,
	},
	body: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		overflow: 'hidden',
		padding: 0,
	},
	conversation: {
		flex: 1,
		paddingTop: 16,
		paddingLeft: 24,
		paddingRight: 24,
	},
	inputContainer: {
		boxSizing: 'border-box',
		padding: 24,
		borderTop: `1px solid ${aceGray}`,
		backgroundColor: background,
		flexShrink: 0,
		borderBottomLeftRadius: 12,
		borderBottomRightRadius: 12,
	},
	userMessageAttachments: {
		display: 'flex',
		gap: 8,
		marginTop: 8,
		flexWrap: 'wrap',
	},
	attachmentThumbnail: {
		maxWidth: 200,
		maxHeight: 200,
		borderRadius: 8,
		border: `1px solid ${aceGray}`,
		objectFit: 'contain',
	},
	generatedImages: {
		display: 'flex',
		gap: 12,
		marginTop: 12,
		flexWrap: 'wrap',
	},
	generatedImage: {
		maxWidth: 400,
		maxHeight: 400,
		borderRadius: 12,
		border: `1px solid ${aceGray}`,
		objectFit: 'contain',
		boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
	},
	processingMessage: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		padding: '12px 16px',
		backgroundColor: '#f8fafc',
		borderRadius: 8,
		marginTop: 8,
		fontSize: 14,
		color: '#64748b',
	},
	errorMessage: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		padding: '12px 16px',
		backgroundColor: '#fef2f2',
		borderRadius: 8,
		marginTop: 8,
		fontSize: 14,
		color: '#dc2626',
	},
	generatedImageActions: {
		display: 'flex',
		justifyContent: 'center',
		marginTop: 12,
		marginBottom: 12,
	},
	sparklesIcon: {
		color: colors.primary.main,
	},
});
